import { DashboardConfig } from '../../../../common/components/dashboards/types';
import { Languages } from '../../../../constants';
import { MidCareerRecruitmentPage } from '../../../../pages/dashboards/RecruitmentStoryboard/MidCareerRecruitmentPage';
import { NewGradRecruitmentPage } from '../../../../pages/dashboards/RecruitmentStoryboard/NewGradRecruitmentPage';
import { ApplicationDataFields, DataTypes } from '../../../../types';

const dashboardId = 'recruitment-storyboard';

export const IPexRecruitmentStoryboardDashboardConfig: DashboardConfig = {
  id: dashboardId,
  title: {
    [Languages.EN]: 'Recruitment Storyboard',
    [Languages.JA]: '採用ダッシュボード',
  },
  enabled: true,
  dashboardOptions: {
    allowedFilterFields: [
      {
        dataType: DataTypes.APPLICATION,
        dataField: ApplicationDataFields.CUSTOM_FILTER_2,
      },
      {
        dataType: DataTypes.APPLICATION,
        dataField: ApplicationDataFields.CUSTOM_FILTER_3,
      },
      {
        dataType: DataTypes.APPLICATION,
        dataField: ApplicationDataFields.CUSTOM_FILTER_4,
      },
      {
        dataType: DataTypes.APPLICATION,
        dataField: ApplicationDataFields.CUSTOM_FILTER_5,
      },
      {
        dataType: DataTypes.APPLICATION,
        dataField: ApplicationDataFields.CUSTOM_FIELD_1,
      },
    ],
  },
  pages: [
    {
      pageId: '1',
      dashboardId,
      pageNumber: 1,
      enabled: true,
      title: {
        [Languages.EN]: 'New Grad Recruitment',
        [Languages.JA]: '新卒採用',
      },
      pageOptions: {
        dataView: {
          enabled: false,
        },
        filterTray: {
          enabled: true,
        },
        segmentationLevel1: {
          enabled: false,
        },
        segmentationLevel2: {
          enabled: false,
        },
        benchmark: {
          enabled: false,
        },
        forecast: {
          enabled: false,
        },
        timeOptions: {
          timeSliderEnabled: false,
        },
      },
      gridRows: 1,
      gridCols: 1,
      configType: 'pageComponent',
      pageComponent: NewGradRecruitmentPage,
    },
    {
      pageId: '2',
      dashboardId,
      pageNumber: 2,
      enabled: true,
      title: {
        [Languages.EN]: 'Mid-Career Recruitment',
        [Languages.JA]: '中途採用',
      },
      pageOptions: {
        dataView: {
          enabled: false,
        },
        filterTray: {
          enabled: true,
        },
        segmentationLevel1: {
          enabled: false,
        },
        segmentationLevel2: {
          enabled: false,
        },
        benchmark: {
          enabled: false,
        },
        forecast: {
          enabled: false,
        },
        timeOptions: {
          timeSliderEnabled: false,
        },
      },
      gridRows: 1,
      gridCols: 1,
      configType: 'pageComponent',
      pageComponent: MidCareerRecruitmentPage,
    },
  ],
};
